import * as t from "io-ts";

export const ObjectFieldChangeValidator = t.intersection([
  t.type({
    id: t.string,
    objectChangeLogId: t.string,
    fieldName: t.string,
  }),
  t.partial({
    fromValue: t.string,
    toValue: t.string,
  }),
]);

export const ObjectFieldChangeArrayValidator = t.array(ObjectFieldChangeValidator);

export type ObjectFieldChange = t.TypeOf<typeof ObjectFieldChangeValidator>;
export type ObjectFieldChangeArray = t.TypeOf<typeof ObjectFieldChangeArrayValidator>;
